<template>
	<footer class="footer">
		<div class="footer__container">

			<div class="footer__box footer__box--mod1">
				<router-link to="/">
					<img class="footer__image" src="@/assets/img/white-logo.png" alt="Logo">
				</router-link>
			</div>
			<div class="footer__box footer__box--mod2">
				<a href="mailto:info@ratesautotransport.com">info@ratesautotransport.com</a>
				<div />
				<router-link to="/legal/terms-conditions">{{ $t('footer.terms') }}</router-link>
				<div />
				<router-link to="/legal/privacy-policy">{{ $t('footer.privacy') }}</router-link>
			</div>
			<div class="footer__box footer__box--mod3">
				<a href="https://www.instagram.com/ratesautotransport/" target="_blank" rel="noopener noreferrer">
					<img src="@/assets/img/Instagram.svg" alt="Instagram Icon" />
				</a>
			</div>
			<div class="footer__box footer__box--mod4">
				<p class="footer__copyright">{{ $t('footer.copyright') }}</p>
			</div>
		</div>
	</footer>
</template>

<script setup>
</script>

<style scoped>
.footer {
	width: 100%;
	height: fit-content;
	display: flex;
	justify-content: center;
	align-items: center;
}

.footer__container {
	display: flex;
	background-color: var(--SecondaryColor);
	margin-block: 5vh;
	border-radius: 1rem;
	width: 98%;
	justify-content: space-between;
	padding: 10px 30px;
	/* padding: 10px 20px 10px 20px; */
}

.footer__image {
	width: 100%;
	max-width: 13.75rem;
	height: auto;
}

.footer__box {
	color: var(--ComplementaryColor03);
	display: flex;
	align-items: center;
	font-size: clamp(1rem, 1.1vw, 1.8rem);
}

a {
	color: var(--ComplementaryColor03);
	text-decoration: none;
	font-weight: 400;
}

a:hover {
	color: white;
	text-decoration: underline;
}

.footer__copyright {
	text-align: center;
	width: 100%;
}

.footer__box--mod2 {
	display: flex;
	gap: 10px;
	align-items: center;
}

.footer__box--mod2 div {
	width: 1px;
	height: 20px;
	border-right: 2px solid white;
}

.footer__box--mod2 a:not(:first-child) {
	margin-inline: 0;
	font-weight: 600;
}

img {
	transition: transform 0.2s ease-in-out;
}

img:hover {
	transform: scale(1.03);
	cursor: pointer;
}

@media only screen and (max-width: 768px) {
	.footer__container {
		flex-direction: column;
		align-items: center;
		gap: 4.5rem;
		margin-block: 2vh;
		padding-inline: 10vw !important;
		border-radius: 2.5rem;
	}

	.footer__box {
		font-size: 1.8rem;
	}

	.footer__box--mod2 {
		flex-direction: column;
		align-items: center;
		gap: 1.5rem;
		margin: 0 !important;
		padding: 0 !important;
	}

	.footer__box--mod2 div {
		display: none;
	}

	.footer__image {
		width: auto;
		max-width: none;
		max-height: 6.4rem;
		margin-top: 2.5rem;
		height: 100%;
	}

	.footer__copyright{
		font-weight: 600;
	}
}
</style>